<form name="postexameditorform">
  <h3 ng-bind="vm.exam.template.displayname"></h3>


  <!-- Biopsy fields -->
  <div ng-show="vm.exam.template.biopsy" class="panel panel-default">
    <div class="panel-heading">Biopsien</div>
    <div class="panel-body">

      <!-- biopsy referral doctor -->
      <label for="patho">Labor/Pathologie</label>

      <!-- Arztsuche -->
      <div class=" row">
        <!-- Arztsuche - -->
        <!--                <div class="form-group  col-xs-12" ng-hide="vm.newref.doctor._id">
                            <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>
                        </div>-->
        <div class="form-group col-xs-12" ng-show="vm.newref.doctor._id">
          <div class="input-group">
            <input type="text" class="form-control"
                   id="pdoctorname"
                   tabindex="0"
                   readonly
                   ng-model="vm.newref.doctor.fname">
            <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>
                    </button>
                </span>
          </div>
        </div>
      </div>


      <!-- biopsy referral fields -->
      <label for="pathdiag">Diagnose/Begründung</label>
      <input type="text" tabindex="901" id="pathdiag" class="form-control" ng-model="vm.newref.diag">

      <label for="pathcomment">Kommentar/Anweisung</label>
      <textarea tabindex="901" id="pathcomment" class="form-control" ng-model="vm.newref.pathcomment"></textarea>

      <!-- Biopsy fields -->
      <biopsyfield field="bf" bvalues="vm.exam.template.biopsy.values"
                   ng-init="bf.label  = 'PE ' + ($index + 1) + ' ' + vm.exam.template.type"
                   ng-repeat="bf in vm.exam.template.biopsy.biopsies">
      </biopsyfield>
    </div>
  </div> <!-- Biopsy group-->

  <!-- special fields -->
  <div class="panel panel-default">
    <div class="panel-heading"><h4>Befundzusammenfassung</h4></div>
    <div class="panel-body">
      <examfield field="vm.exam.template.diagnosis" on-field-change="vm.save()"
                 ng-show="vm.exam.template.diagnosis"></examfield>
      <examfield field="vm.exam.template.recommendation" on-field-change="vm.save()"
                 ng-show="vm.exam.template.recommendation"></examfield>
      <examfield field="vm.exam.template.comment" on-field-change="vm.save()"
                 ng-show="vm.exam.template.comment"></examfield>
    </div>
  </div>


  <h4>Meßwerte erfassen</h4>
  <trackervaluenew trackerid="tracker._id" clientid="vm.exam.patientid" onentrycb="vm.addTrackerValue(trackervalue)"
                   class="spacer-top" ng-repeat="tracker in vm.exam.template.trackers"></trackervaluenew>


  <div class=" spacer-top"></div>

  <!-- exam images/files -->

  <div class="spacer-top spacer-bottom btn btn-primary" ng-click="vm.loadimages=true" ng-if="!vm.loadimages && vm.exam.files && vm.exam.files.length > 0">
    Bilder der Untersuchung laden
  </div>

  <examfiles  ng-if="vm.loadimages" examid="vm.exam._id"></examfiles>



  <!-- fieldgroups -->
  <div ng-repeat="fieldgroup in vm.exam.template.fieldgroups">
    <fieldgroup fieldgroup="fieldgroup" gi="{{$index}}" on-fieldgroup-change="vm.save()"></fieldgroup>
  </div>


  <div class="spacer-top spacer-bottom" ng-if="vm.exam.open === true">
    <a class="btn btn-info" href="{{vm.previewUrl}}" target="_blank"><i class="fa fa-eye"></i>
      Befundvorschau</a>
  </div>

  <div class="form-group spacer-top">
    <button type="submit" class="btn btn-primary" ng-click="vm.finishEdit()">Editieren beenden und neues PDF
      erstellen
    </button>
    <button type="submit" class="btn btn-danger" ng-click="vm.cancelEdit()">Editieren abbrechen</button>
  </div>
</form> <!-- exam editor form -->
